import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import { textFieldClasses } from '@mui/material/TextField';
import { inputBaseClasses } from '@mui/material/InputBase';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { TextField } from '../TextField';

export const UploadSingleFileRoot = styled('div', {
  name: 'AFUploadSingleFile'
})('');

export const UploadTextField = styled(TextField)(
  ({ theme, error, disabled }) => ({
    [`& .${textFieldClasses.root}`]: {
      outline: 'none',
      [`& .${outlinedInputClasses.root}`]: {
        paddingLeft: theme.spacing(1)
      },
      [`& .${outlinedInputClasses.adornedEnd}`]: {
        paddingRight: theme.spacing(0.5)
      },
      ...(!disabled && {
        ...(!error && {
          '&:hover': {
            [`& .${inputBaseClasses.readOnly}`]: {
              [`& .${outlinedInputClasses.notchedOutline}`]: {
                border: `1px solid ${theme.palette.grey[800]}`
              }
            }
          }
        }),
        '&:focus-visible': {
          [`& .${inputBaseClasses.readOnly}`]: {
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              border: `2px solid ${
                error ? theme.palette.error.main : theme.palette.primary.main
              }`
            }
          }
        }
      }),
      [`& .${inputBaseClasses.root}:not(.Mui-disabled)`]: {
        // we override bg color because we use a readonly TextField but we don't want the grey bg color
        backgroundColor: 'transparent'
      },
      '& .Mui-disabled': {
        pointerEvents: 'none',
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.text.disabled,
        [`& .${inputBaseClasses.input}`]: {
          backgroundColor: 'transparent'
        },
        [`& .${inputBaseClasses.root}`]: {
          '&::placeholder': {
            color: theme.palette.grey[600],
            opacity: 1
          }
        }
      },
      [`& .${inputBaseClasses.input}`]: {
        padding: theme.spacing(1, 1, 1, 0),
        cursor: 'pointer'
      }
    }
  })
);

export const UploadButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,
  '&:focus': {
    borderColor: theme.palette.action.focus
  },
  '&.Mui-disabled.MuiButtonBase-root': {
    backgroundColor: 'transparent'
  }
}));

export const FileUploadIcon = styled(FileUploadOutlinedIcon, {
  shouldForwardProp: prop => prop !== 'disabled'
})(({ theme, disabled }) => ({
  color: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
  '& path': {
    fill: 'currentColor'
  }
}));

export const UploadProgressLoader = styled(CircularProgress)(({ theme }) => ({
  alignSelf: 'center',
  display: 'flex',
  marginRight: theme.spacing(1.25),
  marginLeft: theme.spacing(0.5)
}));

export const UploadFileInput = styled('input')({
  display: 'none',
  '&[type="file"]': {
    // AppFrame has a global selector of input[type="file"] with display:block
    // we need to override it
    display: 'none'
  }
});
